<script>
import useHelper from "@/composables/useHelper";
import {mapActions} from 'pinia';
import {useItemStore} from "@/stores/ItemStore";

const {urlEncode} = useHelper();

window.API = {};
window.API_1484_11 = {};

const scorm =  {
    props: ['content'],
    data() {
        const savedState = this.loadSavedScormState();
        return {
            showExitModal: false,
            name: savedState || {},
            hasSavedState: !!savedState,
            exit_status: ['logout', 'time-out', 'suspend', ''],
            API_1484_11: {
                Initialize: () => {
                    console.log("*** Initialize ***");
                    this.startContentItem(this.$route.params.id, this.$route.params.mission)
                    return "true";
                },
                GetValue: (name) => {
                    console.log("*** GetValue ***", name);
                    if (name === 'cmi.entry') {
                        return this.hasSavedState ? 'resume' : '';
                    }
                    if (name in this.name) {
                        return this.name[name];
                    }
                    return "";
                },
                SetValue: (name, value) => {
                    this.name[name] = value;
                    console.log("*** SetValue ***", name, value);
                    console.log(this.name)
                    console.log('set value varname', urlEncode(name));
                    console.log('set value varvalue', urlEncode(value));
                    let lms_value = urlEncode(value);
                    if ((name === 'cmi.completion_status' && lms_value.toLowerCase() === 'completed')
                        ||
                        (name === 'cmi.success_status' && lms_value.toLowerCase() === 'passed')) {
                      this.$emit('scorm-completed', {
                        'status': 'completed',
                      });
                    }
                    return "true";
                },
                Terminate: () => {
                    console.log("*** Terminate ***");
                    this.persistScormState();
                    if ('cmi.exit' in this.name && this.exit_status.includes(this.name['cmi.exit'].toLowerCase())) {
                        let message = ''
                        if (this.name['cmi.exit'] !== 'suspend') {
                            this.clearScormState();
                        }

                        if (this.name['cmi.exit'] === 'suspend') {
                            message = ', You can resume later from where you left off. '
                        }

                        this.$emit('scorm-completed', {
                            'status': 'exist',
                            'title': 'Exiting Course',
                            'content': 'You spent a total session time of ' + this.name['cmi.session_time'] + message
                        });
                    }


                    return "true";
                },
                Commit: () => {
                    console.log("*** Commit ***");
                    this.persistScormState();
                    return "true";
                },
                GetLastError: () => {
                    console.log("*** GetLastError ***");
                    return "0";
                },
                GetErrorString: (errorCode) => {
                    console.log("*** GetErrorString ***", errorCode);
                    return "error string";
                },
                GetDiagnostic: (errorCode) => {
                    console.log("*** GetDiagnostic ***", errorCode);
                    return "diagnostic string";
                },

                LMSInitialize: () => {
                    console.log("*** LMSInitialize ***");
                    this.startContentItem(this.$route.params.id, this.$route.params.mission)
                    return "true";
                },
                LMSFinish: () => {
                    console.log("*** LMSFinish ***");
                    this.persistScormState();
                    if ('cmi.core.exit' in this.name && this.exit_status.includes(this.name['cmi.core.exit'].toLowerCase())) {
                        let message = ''
                        if (this.name['cmi.core.exit'] !== 'suspend') {
                            this.clearScormState();
                        }

                        if (this.name['cmi.core.exit'] === 'suspend') {
                            message = ', You can resume later from where you left off. '
                        }

                        this.$emit('scorm-completed', {
                            'status': 'exist',
                            'title': 'Exiting Course',
                            'content': 'You spent a total session time of ' + this.name['cmi.core.session_time'] + message
                        });
                    }


                    return "true";
                },
                LMSGetValue: (name) => {
                    console.log("*** LMSGetValue ***", name);
                    console.log('varname', urlEncode(name));
                    if (name === 'cmi.core.entry') {
                        return this.hasSavedState ? 'resume' : '';
                    }
                    if (name in this.name) {
                        return this.name[name];
                    }
                    return "";
                },
                LMSSetValue: (name, value) => {
                    this.name[name] = value;
                    console.log(this.name)
                    console.log("*** LMSSetValue ***", name, value);
                    console.log('set value varname', urlEncode(name));
                    console.log('set value varvalue', urlEncode(value));
                    let lms_value = urlEncode(value);
                    if (name === 'cmi.core.lesson_status' &&
                        ((lms_value.toLowerCase() === 'completed') || (lms_value.toLowerCase() === 'passed'))) {
                        this.$emit('scorm-completed', {
                            'status': 'completed',
                        });
                    }
                    return "true";
                },
                LMSCommit: () => {
                    console.log("*** LMSCommit ***");
                    this.persistScormState();
                    return "true";
                },
                LMSGetLastError: () => {
                    console.log("*** LMSGetLastError ***");
                    return "0";
                },
                LMSGetErrorString: (errorCode) => {
                    console.log("*** LMSGetErrorString ***", errorCode);
                    return "error string";
                },
                LMSGetDiagnostic: (errorCode) => {
                    console.log("*** LMSGetDiagnostic ***", errorCode);
                    return "diagnostic string";
                },
            },
            API: {
                LMSInitialize: () => {
                    console.log("*** LMSInitialize ***");
                    this.startContentItem(this.$route.params.id, this.$route.params.mission)
                    return "true";
                },
                LMSFinish: () => {
                    console.log("*** LMSFinish ***");
                    this.persistScormState();
                    if ('cmi.core.exit' in this.name && this.exit_status.includes(this.name['cmi.core.exit'].toLowerCase())) {
                        let message = ''
                        if (this.name['cmi.core.exit'] !== 'suspend') {
                            this.clearScormState();
                        }

                        if (this.name['cmi.core.exit'] === 'suspend') {
                            message = ', You can resume later from where you left off. '
                        }

                        this.$emit('scorm-completed', {
                            'status': 'exist',
                            'title': 'Exiting Course',
                            'content': 'You spent a total session time of ' + this.name['cmi.core.session_time'] + message
                        });
                    }


                    return "true";
                },
                LMSGetValue: (name) => {
                    console.log("*** LMSGetValue ***", name);
                    console.log('varname', urlEncode(name));
                    if (name === 'cmi.core.entry') {
                        return this.hasSavedState ? 'resume' : '';
                    }
                    if (name in this.name) {
                        return this.name[name];
                    }
                    return "";
                },
                LMSSetValue: (name, value) => {
                    this.name[name] = value;
                    console.log(this.name)
                    console.log("*** LMSSetValue ***", name, value);
                    console.log('set value varname', urlEncode(name));
                    console.log('set value varvalue', urlEncode(value));
                    let lms_value = urlEncode(value);
                    if (name === 'cmi.core.lesson_status' &&
                        ((lms_value.toLowerCase() === 'completed') || (lms_value.toLowerCase() === 'passed'))) {
                        this.$emit('scorm-completed', {
                            'status': 'completed',
                        });
                    }
                    return "true";
                },
                LMSCommit: () => {
                    console.log("*** LMSCommit ***");
                    this.persistScormState();
                    return "true";
                },
                LMSGetLastError: () => {
                    console.log("*** LMSGetLastError ***");
                    return "0";
                },
                LMSGetErrorString: (errorCode) => {
                    console.log("*** LMSGetErrorString ***", errorCode);
                    return "error string";
                },
                LMSGetDiagnostic: (errorCode) => {
                    console.log("*** LMSGetDiagnostic ***", errorCode);
                    return "diagnostic string";
                },
            },
            iframeSrc: "",  // initialize as an empty string
        };
    },
    methods: {
        ...mapActions(useItemStore, ['startContentItem']),
        closeExitModal() {
            this.showExitModal = false;
        },
        getScormStateKey() {
            return `scormState-${this.content.id}`;
        },
        loadSavedScormState() {
            try {
                const raw = localStorage.getItem(this.getScormStateKey());
                if (!raw) return null;
                const parsed = JSON.parse(raw);
                return parsed && Object.keys(parsed).length ? parsed : null;
            } catch (e) {
                return null;
            }
        },
        persistScormState() {
            try {
                localStorage.setItem(this.getScormStateKey(), JSON.stringify(this.name));
            } catch (e) {
                console.warn('Failed to persist SCORM state', e);
            }
        },
        clearScormState() {
            localStorage.removeItem(this.getScormStateKey());
        },
        onLoad() {
            console.log("*** onload ***");
        }
    },
    created() {
        window.API = this.API;
        window.API_1484_11 = this.API_1484_11;
        console.log('window.API', window.API);
        console.log('window.API_1484_11', window.API_1484_11);

        this.iframeSrc = this.content.value;
    },
}

export default scorm;
</script>

<template>
    <div class="md:w-4/5 h-[70vh] w-full flex justify-center items-center border-0 overflow-hidden">
        <iframe v-if="iframeSrc"
                ref="iframe"
                :src="iframeSrc"
                @load="onLoad"
                class="inset-0 w-full h-full border-none border-0"/>
    </div>
</template>
